
import { Component, OnInit, ViewChild } from "@angular/core";
import { AbstractControl, FormControl, FormGroup, Validators } from "@angular/forms";
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import {  IonContent, LoadingController, NavParams, Platform, PopoverController } from "@ionic/angular";
import { Navigator } from "src/app/services/routing/navigator";
import { CashierContentService } from "src/app/services/cashier/cashier-content.service";
import { CashierService } from "src/app/services/cashier/cashier.service";
import { ConfigService } from "src/app/services/config/config.service";
import { EventsService } from "src/app/services/event/event.service";
import { SuccessMessageService } from "src/app/services/message-provider/success-message.service";
import { UtilsService } from "src/app/services/utils/utils.service";
import { CashierBase } from "../../cashier-base/cashier-base";
import { DepositMainLabels } from "../cashier-models/interfaces";
import { InteracModel } from "../cashier-models/models";
import { AffiliateTrackerCallbackParams } from "src/app/interfaces/affliation-interface";


@Component({
  selector: "page-deposit-interac",
  templateUrl: "deposit-interac.html",
})
export class DepositGigadetInteracPage
  extends CashierBase
  implements OnInit
{
  @ViewChild("Content") content: IonContent;
  public error = null;

  public objectKeys = Object.keys;

  // public amount: string;
  private bonusCode: string;
  private bonusID: string;

  public buttonDisabled: boolean = false;
  public showInstaDebit: boolean = false;

  public selectedBonusItem: string;

  // enroll form
  public depositForm: FormGroup;

  public defaultAmounts: any = [];
  private paymentType: any = [];
  public vendorLogoUrl: string = "";

  private inputInteracAmount: AbstractControl;
  public amountSubmitted: number;

  public labels: DepositMainLabels;
  public newWindow;

  public paypalEmail = "";
  public accountsList = null;
  public loading;
  public minAmount;

  // Payment Succesfull Variables
  public params;
  public paymentRequestID;
  public customerId;
  public sessionToken;

  public check_deposit_complete: boolean = false;
  public check_deposit_result: string;

  constructor(
    // protected logger: Logger,
    protected config: ConfigService,
    protected cashierProvider: CashierService,
    protected successMessageService: SuccessMessageService,
    protected events: EventsService,
    // protected mainProvider: MainProvider,
    protected navParams: NavParams,

    protected utils: UtilsService,
    public platform: Platform,
    // public configProvider: ConfigurationProvider,
    private contentProvider: CashierContentService,

    private iab: InAppBrowser,
    private loadingController: LoadingController,
    protected popoverCtrl: PopoverController,
    private navigator:Navigator
  ) {
    super();

    this.labels = new InteracModel();

    this.bonusCode = navParams.get("bonusCode");

    this.successMessageService.clearMessage();

    if (!!this.navParams.get("bonusOffer"))
      this.bonusCode = this.navParams.get("bonusOffer");

    if (!!this.navParams.get("navigateBackPage")) {
      this.loading = this.loadingController.create({
        message: "Loading Interac...",
      });

      this.loading.then(ld => {
        ld.present();
      });

      setTimeout(() => {
        this.loading.then(ld => {
          ld.dismiss();
        })
      }, 650);
    }
  }

  ngOnInit() {
    this.buttonDisabled = false;

    this.depositForm = new FormGroup({
      inputInteracAmount: new FormControl("", [Validators.required]),
    });
    this.inputInteracAmount = this.depositForm.get("inputInteracAmount");
  }

  ionViewWillEnter() {
    let vm = this;

    this.contentProvider
      .getPageConfig("interac")
      .then((response: DepositMainLabels) => {
        this.labels = response;
      });

    //Webservice Calls to get Credit Card Data

    this.cashierProvider.getActivePaymentTypes("GDIE").subscribe(
      (response: any) => {
        if (response.result) {
          console.log("Payment Details", response.payload);
          vm.paymentType = response.payload;
          vm.minAmount = this.paymentType[0].min; 

          let i: number = 0;
          this.defaultAmounts = [];

          while (i < 11) {
            if (
              typeof vm.paymentType[0]["default_amt_" + (i + 1)] !== "undefined"
            ) {
              vm.defaultAmounts.push(
                vm.paymentType[0]["default_amt_" + (i + 1)]
              );
            } else {
              break;
            }
            i++;
          }

          vm.vendorLogoUrl = vm.utils.getCDNAsset(
            "deposit/" + vm.paymentType[0].image_url
          );
        }
      },
      (error) => {}
    );
  }

  /*ionViewDidEnter(){
    this.events.subscribe('event:deposit:approved', (data) => {
      console.log('interac--',data)
      let depositEventData: AffiliateTrackerCallbackParams = {
        customer_id: this.cashierProvider.customer.customerId,
        amount:  data.parametersMap.amount,
        paymentMethod: "INTERAC"
      }
      setTimeout(() => this.events.publish('event:deposit', depositEventData), 2000);
    });
  }

  ionViewCanLeave() {
    this.events.unsubscribe('event:deposit:approved');
  }*/

  selectedDepositBonusOffer($event) {
    this.bonusCode = $event.selectedbonusOffer.campaign_code;
  }

  showLoading() {
    this.hideLoading();
    this.loading = this.loadingController.create({
      message: "Checking Account...",
    });
    this.loading.present();
  }

  hideLoading() {
    try {
      this.loading.dismiss();
    } catch (e) {}
  }

  onSubmit() {
    let data: any = {};
    data.amount = this.inputInteracAmount.value;
    data.bonusCode = this.bonusCode;
    data.bonusID = this.bonusID;
    data.currency_code = this.config.getConfig().DEFAULT_CURRENCY;
    data.payment_type_code = "MNI";
    let interacDepositType = "CPI";
    let newWindowStrategy =
      this.config.getConfig().INTERAC_NEW_WINDOW == "1" ? true : false;

    this.cashierProvider.callDeposit(data).subscribe(
      (response: any) => {
        if (response && !!response.result) {
          this.cashierProvider
            .getAuthToken(
              data.amount,
              interacDepositType,
              response.payload.paymentRequestID
            )
            .subscribe((token) => {
              if (token.result == "1") {
                let params = {
                  transaction: response.payload.paymentRequestID,
                  token: token.token,
                };

                let queryString = Object.keys(params)
                  .map((key) => key + "=" + params[key])
                  .join("&");
                let url = `${
                  this.config.getConfig().INTERAC_WEBSITE_URL
                }?${queryString}`;

                if (this.isMobileApp() && newWindowStrategy) {
                  this.newWindow = this.iab.create(
                    url,
                    "",
                    "location=no,footer=no,hardwareback=no,hidenavigationbuttons=yes,closebuttoncaption=< back"
                  );
                  setTimeout(() => {
                    let interval = setInterval(() => {
                        this.newWindow.executeScript(
                            { code: "window._window_has_closed" },
                            (val) => {
                                if (val[0]) {
                                    console.log('Execute close script');     
                                    this.newWindow.close();
                                    clearInterval(interval);
                                }
                            }
                        );
                    }, 500);
                },3000);
                } else {
                  if (newWindowStrategy) {
                    let w: any = window;
                    this.newWindow = w.open("about:blank", "_system");
                    this.newWindow.location = url;
                    this.newWindow.focus();
                  } else {
                    this.navigator.navigateTo(
                      "DepositInteracActionPage",
                      { multipleModals: true },
                      {
                        amount: this.inputInteracAmount.value,
                        paymentRequestID: response.payload.paymentRequestID,
                        bonusCode: this.bonusCode,
                        bonusID: this.bonusID,
                        url: url,
                      }
                    );
                  }
                }

                return false;
              } else {
                this.newWindow.close();
                this.buttonDisabled = false;
                // handle all deposit errors in base
                this.error = this.handleError(null);
                this.content.scrollToTop();
              }
            });
        }
      },
      (error) => {
        if (this.newWindow) {
          this.newWindow.close();
        }

        this.buttonDisabled = false;
        // handle all deposit errors in base
        this.error = this.handleError(error);
        this.content.scrollToTop();
        console.error(error);
      }
    );

    return false;
  }

  get isMobile() {
    return this.platform.is("mobile") || this.platform.is("mobileweb")
      ? true
      : false;
  }

  isMobileApp() {
    return this.platform.is("cordova");
  }

  onBack = () => {
    if (!!this.navParams.get("navigateBackPage")) {
      let navigateBackPage = this.navParams.get("navigateBackPage");
      if (navigateBackPage == "default") {
        //Navigator.toLobby();
        this.navigator.navigateTo("DepositMainComponent", { multipleModals: true });
      } else {
        this.navigator.navigateTo(navigateBackPage);
      }
    } else {
      this.navigator.back();
    }
  };

  onBonusSelect(index, offer) {
    this.bonusCode = offer.campaign_code;
    this.selectedBonusItem = index;

    //Deposit Event Information
    this.bonusID = offer.id;
  }

  onAmountSelected(amount) {
    this.inputInteracAmount.setValue(amount);
    this.depositForm.get("inputInteracAmount").markAsDirty();
    this.depositForm.get("inputInteracAmount").markAsTouched();
  }

  // For Checking Payment Success

  getHashValue(key) {
    var matches = location.hash.match(new RegExp(key + "=([^&]*)"));
    return matches ? matches[1] : null;
  }
}
